import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Paper,
} from "@mui/material";
import {
  Description as TemplateIcon,
  Campaign as BroadcastIcon,
} from "@mui/icons-material";

const BroadcastNavigation = ({ activeSection, onSectionChange }) => {
  const sections = [
    {
      id: "templates",
      label: "Templates",
      icon: <TemplateIcon />,
    },
    {
      id: "broadcast-messages",
      label: "Broadcast Messages",
      icon: <BroadcastIcon />,
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        // borderRight: "1px solid #e0e0e0",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Header */}
      <Box sx={{ p: 3,
        //  borderBottom: "1px solid #e0e0e0"
          }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#333", fontFamily: 'Poppins, sans-serif' }}>
          Broadcast
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontFamily: 'Poppins, sans-serif' }}>
          Manage templates and campaigns
        </Typography>
      </Box>

      {/* Navigation List */}
      <List sx={{ pt: 1 }}>
        {sections.map((section) => {
          const isActive = activeSection === section.id;
          return (
            <ListItem key={section.id} disablePadding>
              <ListItemButton
                onClick={() => onSectionChange(section.id)}
                sx={{
                   mx: 1,
                  mb: 0.5,
                  borderRadius: 1,
                  cursor: "pointer",
                  boxShadow: "none",
                  position: "relative",
                  bgcolor: isActive ? "#eef3ff" : "#fff",
                  color: isActive ? "#4f7cff" : "#666",
                  borderRight: isActive
                  ? "4px solid #4f7cff"
                  : "4px solid transparent",
                 "&:hover": { 
                 bgcolor: "#f5f7fb",
                },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "#1976d2" : "#666",
                    minWidth: 40,
                  }}
                >
                  {section.icon}
                </ListItemIcon>
                <ListItemText
                  primary={section.label}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontWeight: isActive ? 600 : 500,
                      fontSize: "14px",
                      fontFamily: 'Poppins, sans-serif',
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default BroadcastNavigation;
